import React, {useEffect, useState, useRef} from "react";
import {
    SearchFieldWrapper,
    SearchFieldInnerWrapper,
    SearchButton,
    InputWrapper,
    Input,
    Icon,
} from "./StyledSearchFieldComponents";
import {useSelector} from "react-redux";
import {HandleClick} from "Helpers/LinkHelper";
import {useGlobal} from "reactn";

export const SearchField = ({SearchUrl, SearchText}) => {
    const state = useSelector(({searchField}) => searchField);
    const inputEl = useRef(null);
    const [theme] = useGlobal("theme");

    const OnSearch = (e) => {
        e.preventDefault();
        let query = inputEl.current.value;

        if (query.length) {
            HandleClick(e, `${SearchUrl}?query=${query}`);
        }
    };

    const OnKeyDown = (e) => {
        if (e.key === "Enter") {
            OnSearch(e);
        }
    };
    const FocusInput = (e) => {
        e.preventDefault();
        inputEl.current.focus();
    };

    return (
        <SearchFieldWrapper backgroundImage={theme.colors.lightgrey} justifyContent="center">
            <SearchFieldInnerWrapper
                smallAlignContent="center"
                alignItems="center"
                justifyContent="center"
                padding="1rem"
                max-width="615px"
            >
                <InputWrapper onClick={(e) => FocusInput(e)}>
                    <SearchButton onClick={(e) => OnSearch(e)}>
                        <Icon className="icon-search"></Icon>
                    </SearchButton>
                    <Input
                        ref={inputEl}
                        padding="0 0 0 1rem"
                        placeholder={SearchText}
                        // placeholder={searchText}
                        border="1px solid #8f8f8f"
                        onKeyDown={(e) => OnKeyDown(e)}
                    />
                </InputWrapper>
            </SearchFieldInnerWrapper>
        </SearchFieldWrapper>
    );
};
